import React from 'react';

export const LegalMentions = () => {
  const currentDate = "29 juillet 2026";

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <p className="text-[10px] text-content-muted italic">Dernière mise à jour : {currentDate}</p>
      
      <section className="space-y-2">
        <h2 className="text-sm font-semibold text-[#c8a153]">1. Édition du site</h2>
        <p className="text-xs text-content-muted leading-relaxed">
          La plateforme SaaS <strong>L'IAmani</strong> (accessible à l'adresse gestion.l-iamani.com) est éditée par :
        </p>
        <p className="text-xs text-content-muted leading-relaxed">
          <strong>Emeni Jelassi</strong><br/>
          Exploitant en nom propre — formalités d'immatriculation en cours<br/>
          16 rue des Écluses Saint-Martin, 75010 Paris, France
        </p>
        <p className="text-xs text-content-muted leading-relaxed">
          L'accès et l'utilisation de cet outil sont actuellement mis à disposition à titre gratuit.
        </p>
        <p className="text-xs text-content-muted leading-relaxed">
          Pour toute demande ou information, vous pouvez contacter l'éditeur à l'adresse suivante :<br/>
          <a href="mailto:contact@l-iamani.com" className="text-content hover:text-[#c8a153] transition-colors">contact@l-iamani.com</a>
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-sm font-semibold text-[#c8a153]">2. Hébergement</h2>
        <p className="text-xs text-content-muted leading-relaxed">
          L'infrastructure applicative et la base de données sont hébergées par :<br/>
          <strong>Cloudflare, Inc.</strong><br/>
          101 Townsend St, San Francisco, CA 94107, USA
        </p>
        <p className="text-xs text-content-muted leading-relaxed">
          L'ensemble des données est stocké et sécurisé sur l'infrastructure Cloudflare (Cloudflare Pages, D1 Database), en conformité avec la réglementation en vigueur.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-sm font-semibold text-[#c8a153]">3. Propriété Intellectuelle</h2>
        <p className="text-xs text-content-muted leading-relaxed">
          L'ensemble des éléments constituant la plateforme L'IAmani (code source, algorithmes, interfaces, arborescence, base de données) est la propriété exclusive de l'éditeur du site. Toute reproduction, représentation, ou exploitation non autorisée est strictement interdite sans l'accord préalable de son auteur.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-sm font-semibold text-[#c8a153]">4. Responsabilité</h2>
        <p className="text-xs text-content-muted leading-relaxed">
          L'éditeur s'efforce de fournir un outil performant et sécurisé. Toutefois, l'application étant mise à disposition gratuitement "en l'état", l'éditeur décline toute responsabilité quant aux éventuelles interruptions de service, bugs, ou pertes de données, ainsi que leurs conséquences sur l'activité des utilisateurs.
        </p>
      </section>
    </div>
  );
};
